import DeleteDevicesContainer from './containers/DeleteDevicesContainer'

export default DeleteDevicesContainer
